import styled from 'styled-components';
import { Copytext } from './Copytext';
import {
  CopyBigSkin,
  CopyStandardSkin,
  CopyFineprintSkin,
} from './CopytextSkins';

export const CopyBig = styled(Copytext)`
  ${CopyBigSkin}
`;

export const CopyStandard = styled(Copytext)`
  ${CopyStandardSkin}
`;

export const CopyFineprint = styled(Copytext)`
  ${CopyFineprintSkin}
`;

export { Copytext } from './Copytext';
